var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 4.28112C6.6665 3.38939 7.38939 2.6665 8.28112 2.6665H24.7186C25.6103 2.6665 26.3332 3.38939 26.3332 4.28112V27.2741C26.3332 28.1658 25.6103 28.8887 24.7186 28.8887H8.28112C7.38939 28.8887 6.6665 28.1658 6.6665 27.2741V4.28112ZM21.9626 11.4071C21.9626 14.4242 19.5168 16.87 16.4996 16.87C13.4825 16.87 11.0367 14.4242 11.0367 11.4071C11.0367 8.38997 13.4825 5.94411 16.4996 5.94411C19.5168 5.94411 21.9626 8.38997 21.9626 11.4071ZM9.67086 23.4257C9.21829 23.4257 8.85142 23.7926 8.85142 24.2451C8.85142 24.6977 9.2183 25.0646 9.67086 25.0646H23.3283C23.7808 25.0646 24.1477 24.6977 24.1477 24.2451C24.1477 23.7926 23.7808 23.4257 23.3283 23.4257H9.67086Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b16fb52e2043575de2f57748d7c6f20a.svg";
export { ForwardRef as ReactComponent };